import type { CourseModule } from "@/core/types";
import { lektionFormatvorlagenGrundlagen } from "./lektion-01-grundlagen";
import { lektionUeberschriftenebenen } from "./lektion-02-ebenen";
import { lektionFormatvorlagenAnpassen } from "./lektion-03-anpassen";
import { lektionWeitereVorlagen } from "./lektion-04-weitere-vorlagen";
import { lektionInhaltsverzeichnis } from "./lektion-05-inhaltsverzeichnis";

export const modulFormatvorlagen: CourseModule = {
  id: "formatvorlagen",
  title: "Formatvorlagen und Dokumentstruktur",
  summary:
    "Absätzen eine Rolle geben statt sie nur zu formatieren – die Grundlage für " +
    "Gliederung, Navigation und ein automatisches Inhaltsverzeichnis.",
  level: "Grundlagen",
  lessons: [
    lektionFormatvorlagenGrundlagen,
    lektionUeberschriftenebenen,
    lektionFormatvorlagenAnpassen,
    lektionWeitereVorlagen,
    lektionInhaltsverzeichnis,
  ],
};
